import TextInput from './TextInput'
export default TextInput
export { LABEL_POSITION } from './TextInput'
export { Input, Label } from './TextInput.styles'
export type { TextInputProps } from './TextInput'
